import { logEvent } from "firebase/analytics";
import React from "react";
import { useNavigate } from "react-router-dom";
import { analytics } from "../../utils/firebase";
import { pushGaEvent } from "../../utils/ga_events";

export default function DashboardCard({ item }) {
  let navigation = useNavigate();
  const handleNavigation = (item) => {
    pushGaEvent(item?.title?.toUpperCase() + "_SYNC_BUTTON_CLICKED");
    navigation(`${item?.link}/sync_your_content`);
  };
  return (
    <div
      className={`${
        item?.login ? "border-[2px] border-[#5463FF]" : "shadow-login-card"
      } px-[16px] rounded-[12px] mb-[16px]`}
    >
      <div
        className={`${
          item?.login ? "mt-[19px]" : "h-[80px]"
        } flex_thing justify-between  max-w-[1000px] md:max-w-[365px] w-[98%]`}
      >
        <div className="flex_thing">
          <img src={item.icon} alt={item.title} />
          <h1 className="ml-[12px] text-[#161616] text-[24px] font-bold">
            {item.title}
          </h1>
        </div>
        {item?.login ? (
          <button
            onClick={() => handleNavigation(item)}
            className="w-[112px] h-[48px] filter-button justify-center bg-white rounded-[8px] border border-[#b9b9b9] hover:shadow-md text-[#5463FF] hover:bg-[#EEEFFF]"
          >
            Sync
          </button>
        ) : (
          <p
            onClick={() => item?.onPress()}
            className="text-blue text-[16px] cursor-pointer hover_connect w-[112px] flex justify-center items-center h-[48px] rounded-[8px]"
          >
            Connect
          </p>
        )}
      </div>
      {item.login && (
        <div className="mt-[24px] pb-[16px]">
          <p className="text-[#585858] text-[13px] mb-[8px]">
            You are logged in as
          </p>
          <div className="flex_thing justify-between">
            <div className="flex_thing">
              <img
                className="w-[30px] h-[30px] rounded-[50%]"
                src={item?.photo}
                alt=""
              />

              <p className="ml-[8px] text-[#161616]">@{item?.name}</p>
            </div>
            <div>
              <p
                onClick={() => item?.signout()}
                className="text-[14px] text-[#585858] cursor-pointer pr-[38px]"
              >
                Logout
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
